import { useEffect, useRef } from "react";

export default function useFirstRender() {
    const isFirstRender = useRef<boolean>(true);

    useEffect(() => {
        isFirstRender.current = false;
    }, []);

    // eslint-disable-next-line react-hooks/refs
    return isFirstRender.current;
}
